import { Component, OnInit } from '@angular/core';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-environmental-sustainability-solutions',
  templateUrl: './environmental-sustainability-solutions.component.html',
  styleUrls: ['./environmental-sustainability-solutions.component.css']
})
export class EnvironmentalSustainabilitySolutionsComponent implements OnInit {

  faCheckCircle = faCheckCircle;

  constructor() { }

  ngOnInit(): void {
  }

}
